import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { DollarSign, ChevronRight } from 'lucide-react';

const brl = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);

const ComissaoProjetadaCard = () => {
  const navigate = useNavigate();
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    api.get('/dashboard/comissao-projetada')
      .then(res => setDados(res.data))
      .catch(() => setErro(true))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
      {/* Header */}
      <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 bg-emerald-50 rounded-lg flex items-center justify-center">
            <DollarSign size={16} className="text-emerald-600" />
          </div>
          <div>
            <p className="text-sm font-black text-slate-800">Comissão Projetada</p>
            <p className="text-xs text-slate-400">Recebida, a receber e atrasada</p>
          </div>
        </div>
        <button onClick={() => navigate('/inteligencia-comercial')}
          className="flex items-center gap-1 text-xs font-black text-[#0A3D73] hover:opacity-70 transition-opacity">
          Ver detalhes <ChevronRight size={11} />
        </button>
      </div>

      {/* Body */}
      {loading ? (
        <div className="flex items-center justify-center py-6">
          <div className="w-6 h-6 border-4 border-slate-200 border-t-[#0A3D73] rounded-full animate-spin" />
        </div>
      ) : erro ? (
        <div className="flex items-center justify-center py-6">
          <p className="text-sm text-red-500 font-semibold">Erro ao carregar dados</p>
        </div>
      ) : !dados ? (
        <div className="flex items-center justify-center py-6">
          <p className="text-sm text-slate-400 font-semibold">Sem dados de vencimentos</p>
        </div>
      ) : (
        <div className="px-5 py-4">
          <div className="flex items-center gap-3">
            <div className="flex-1 text-center bg-emerald-50 border border-emerald-200 rounded-lg py-3 px-2">
              <p className="text-sm font-black text-emerald-600 leading-none">{brl(dados.comissao_recebida)}</p>
              <p className="text-[10px] font-black uppercase tracking-wide text-emerald-500 mt-1.5">Recebida</p>
            </div>
            <div className="flex-1 text-center bg-blue-50 border border-blue-200 rounded-lg py-3 px-2">
              <p className="text-sm font-black text-[#0A3D73] leading-none">{brl(dados.comissao_a_receber)}</p>
              <p className="text-[10px] font-black uppercase tracking-wide text-blue-400 mt-1.5">A Receber</p>
            </div>
            <div className="flex-1 text-center bg-red-50 border border-red-200 rounded-lg py-3 px-2">
              <p className="text-sm font-black text-red-600 leading-none">{brl(dados.comissao_atrasada)}</p>
              <p className="text-[10px] font-black uppercase tracking-wide text-red-400 mt-1.5">Atrasada</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ComissaoProjetadaCard;
